import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

import { IOrganization } from '@shared/models/organization';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectAuthToken, selectAuthUser } from '@state/auth/auth.selectors';

import { IframeModalService } from '../iframe-modal/iframe-modal.service';

const url = `${environment.api}/deal/submission`;

export const openSubmitDeal = (magicToken?: string) => {
  const finalUrl = magicToken ? `${url}?magic_token=${magicToken}` : url;
  window.location.href = finalUrl;
};

@UntilDestroy()
@Component({
  selector: 'app-submit-a-deal-button',
  templateUrl: './submit-a-deal.component.html',
  styleUrls: ['./submit-a-deal.component.scss'],
})
export class SubmitADealComponent implements OnInit {
  @Input() wrapper: TemplateRef<any> | null = null;
  @Output() closeCallback = new EventEmitter<void>();

  protected text = 'Submit a Deal';
  protected isLoggedIn = false;

  protected modalOpen = false;
  protected userOrg: IOrganization | null | undefined;

  protected iframePageSrc = url;
  protected showIframe = false;

  constructor(
    private store: Store<AppState>,
    private iframeModal: IframeModalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectAuthToken)
      .pipe(untilDestroyed(this))
      .subscribe((token) => {
        this.isLoggedIn = !!token;
      });

    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.userOrg = user?.organization;
      });
  }

  handleClick(): void {
    if (this.isLoggedIn && !this.userOrg) {
      this.modalOpen = true;
    } else {
      this.iframeModal.open(
        this.iframePageSrc,
        undefined,
        this.isLoggedIn,
        this.closeCallback && this.isLoggedIn
          ? this.closeCallback.emit.bind(this.closeCallback)
          : undefined
      );
    }
  }

  navigateToMyOrganization(): void {
    this.modalOpen = false;
    this.router.navigate(['/my-organization']);
  }
}
